import React from "react";
import {IconBallAmericanFootball, IconScissors, IconCar, IconMovie, IconMicrophone} from "@tabler/icons-react";

import Header from "@fig/client/components/Header";
import classes from "./Header.module.scss";
import BaseFooter from "@fig/client/components/Footer";

interface FooterProps {}

export default function Footer() {
  return (
    <BaseFooter
      sections={[
        {
          title: "Fig",
          links: [
            {label: "Solutions", link: "/solutions"},
            {label: "Resources", link: "/resources"},
            //{label: "Careers", link: "/careers"},
            {label: "Terms of Service", link: "/terms-of-service"},
            {label: "Privacy Policy", link: "/privacy-policy"},
          ],
        },
        {
          title: "Solutions",
          links: [
            {label: "Student Athletes", link: "/solutions/nil-student-athletes"},
            {label: "Hair Care Professionals", link: "/solutions/hair-care-professionals"},
            {label: "Influencers", link: "/solutions/influencers"},
            {label: "Ride Sharing", link: "/solutions/ride-sharing"},
            {label: "Film Freelancers", link: "/solutions/film-crew"},
          ],
        },
        {
          title: "Tools",
          links: [
            {label: "Interest Calculator", link: "/tools/retirement-compound-interest-calculator"},
            {label: "Freelancer Rate Calculator", link: "/tools/freelancer-rate-calculator"},
          ],
        },
        {
          title: "Community",
          links: [{label: "Join Discord", link: "https://discord.gg/E9rHJfZ2eg"}],
        },
      ]}
    />
  );
}
